import React, { useRef, useState, useEffect, useCallback } from 'react';

const Dropdown = ({data, name, label, placeholder, idKey, descKey, onHbrSelect, value, searchable = true}) => {
  const selectRef = useRef();
  const initialData = useRef();
  const dropdownList = useRef({});
  const onHbrSelectRef = useRef(onHbrSelect);
  const [state, setState] = useState(data || []);

  const getOptionValue = (item) => String(item?.[idKey] ?? "");

  const getSearchableText = (item) => {
    if (Array.isArray(descKey)) {
      return descKey.map((key) => item?.[key] || "").join(" ").toLowerCase();
    }
    return String(item?.[descKey] || "").toLowerCase();
  };

  useEffect(() => {
    setState(data);
    initialData.current = data;
  }, [data]);

  useEffect(() => {
    onHbrSelectRef.current = onHbrSelect;
  }, [onHbrSelect]);

  useEffect(() => {
    if (selectRef.current && value !== undefined && value !== null && value !== '') {
      selectRef.current.value = String(value);
    }
  }, [value]);

  useEffect(() => {
    const el = selectRef.current;
    if (!el) return;

    const handleChange = (e) => {
      const selectedValue = String(e.target.value || "");
      e.target.selectedData = dropdownList.current[selectedValue];
      onHbrSelectRef.current(e);
    };

    const handleSearch = (e) => {
      const filtered = initialData.current?.filter(item => {
        const text = getSearchableText(item);
        if (e.detail) {
          const searchText = e.detail.value.toLocaleLowerCase();
          if (text.includes(searchText)) {
            item.query = e.detail.value;
            return item;
          }
        }
      });

      if (filtered.length) {
        setState(filtered);
      } else {
        setState([]);
      }
    };

    el.addEventListener('hbr-change', handleChange);
    el.addEventListener('hbr-search', handleSearch);
    el.addEventListener('hbr-clear', handleChange);
    return () => {
      el.removeEventListener('hbr-change', handleChange);
      el.removeEventListener('hbr-search', handleSearch);
      el.removeEventListener('hbr-clear', handleChange);
    };
  }, []);

  const renderDesc = (item) => {
    if(Array.isArray(descKey)) {
      let desc = '';
      descKey.forEach((key, i) => {
        if (i > 0) desc += ' / ';
        desc += item[key];
      });
      return desc;
    }
    return item[descKey];
  }

  return (
    <div className='mb-3'>
      <hbr-select
        name={name}
        ref={selectRef}
        label={label}
        placeholder={placeholder}
        clearable={searchable}
        searchable={searchable}
        required
        value={value === undefined || value === null ? "" : String(value)}
      >
        {state?.map((item, i) => {
          const optionValue = getOptionValue(item);
          dropdownList.current = { ...dropdownList.current, [optionValue]: item };
          return <hbr-option key={`${optionValue}-${i}`} value={optionValue}>{renderDesc(item)}</hbr-option>
        })}
      </hbr-select>
    </div>
  )
};

export default React.memo(Dropdown);